// extracted by mini-css-extract-plugin
export default {"navWrapper":"NavNotAuth_navWrapper__PNsHa","navLink":"NavNotAuth_navLink__Gayfl"};